<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "app",
  components: {},
  methods: {},
  created () {
    const lang = window.navigator.language || window.navigator.userLanguage
    if (lang.includes('zh')) {
      this.$store.commit('setLang', 0)
    } else {
      this.$store.commit('setLang', 1)
    }
  }
};
</script>

<style>
html {
  font-size: 16px;
}
@media only screen and (max-width: 756px) {
  html {
    font-size: 12px !important;
  }
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #000;
  margin: 0;
  white-space: pre-wrap;
}
body {
  margin: 0;
  padding: 0;
}
.page {
  width: 100vw;
  min-width: 320px;
}
.page_content {
  width: 100%;
}
.mt-5 {
  margin-top: 5%;
}
.mb-5 {
  margin-bottom: 5%;
}
.mt-10 {
  margin-top: 10%;
}
.mb-10 {
  margin-bottom: 10%;
}
.mt-20 {
  margin-top: 20%;
}
.mb-20 {
  margin-bottom: 20%;
}
button {
  border: none;
  border-radius: none;
  padding: 0;
  outline: none;
}
button:hover {
  cursor: pointer;
}
.img_base {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.img_widthfix {
  width: 100%;
}
.article-text {
  line-height: 1.5;
  text-align: left;
}
.article-title {
  width: 80%;
  margin: 14% 10% 3% 10%;
  font-size: 1.5rem;
  font-weight: bold;
}
.article-title2 {
  width: 80%;
  margin: 4% 10% 2% 10%;
  font-size: 1.25rem;
  font-weight: bold;
}
.article-title3 {
  width: 80%;
  margin: 0 10% 2% 10%;
  font-size: 1.125rem;
  font-weight: 500;
}
.article-title4 {
  width: 80%;
  margin: 0 10% 1% 10%;
  font-size: 1rem;
  font-weight: 500;
}
.article-subtitle {
  width: 80%;
  margin: 0 10% 2% 10%;
  font-size: 1.125rem;
  font-weight: 500;
}
.article-logobox {
  width: 80%;
  height: 1rem;
  margin: 0 10% 5% 10%;
  display: flex;
  align-items: center;
}
.article-logobox img {
  height: 100%;
}
.article-logobox div {
  font-size: 1.125rem;
  line-height: 1;
  margin: 0 10px;
}
.article-from {
  width: 80%;
  margin: 0 10% 5% 10%;
  font-size: 0.875rem;
}
.article-img {
  width: 80%;
  /* height: 50vw; */
  margin: 5% 10% 3% 10%;
}
.article-img-desc {
  width: 100%;
  text-align: center;
  font-size: 0.75rem;
  font-weight: 420;
  margin-top: 1%;
}
.article-paragraph {
  width: 80%;
  margin: 0 10% 2% 10%;
  font-size: 1rem;
}
/* .article-paragraph:nth-last-child(1) {
  margin: 0 10% 10% 10%;
} */
</style>
